/* global ppd */

import moment from 'moment'

export const SERVER_DATE_FORMAT = 'yyyy/mm/dd'
// Same wire format expressed in moment tokens. The Date.prototype.format
// polyfill (vendor/assets/javascripts/date.format.js) uses lowercase tokens
// for date parts; moment uses uppercase. Pick the one that matches your
// formatter — they are not interchangeable.
export const SERVER_DATE_FORMAT_MOMENT = 'YYYY/MM/DD'

// Normalize ISO date-only strings (YYYY-MM-DD) to slash format to prevent
// new Date() from interpreting them as UTC midnight, which shifts the date
// back one day in western hemisphere timezones.
const normalizeDateString = (str) => str ? str.replace(/^(\d{4})-(\d{2})-(\d{2})$/, '$1/$2/$3') : str

export const formatDate = (dateString, format) => {
  if (!dateString) { return '' }
  try {
    const date = new Date(normalizeDateString(dateString).replace(/\s[+-]\d{4}/, ''))
    if (isNaN(date.getTime())) { return dateString }
    return date.format(format || ppd.dateFormat)
  } catch (e) {
    return ''
  }
}

export const formatTime = (dateString) => {
  return formatDate(dateString, ppd.timeFormat)
}

export const formatTimeAgo = (dateTimeString) => moment(dateTimeString).fromNow()

export const formatDateTime = (dateString, joiner = '') => {
  return `${formatDate(dateString)} ${joiner} ${formatTime(dateString)}`
}

export const daysSinceNow = (dateString, sinceDateString) => {
  try {
    const now = sinceDateString ? new Date(normalizeDateString(sinceDateString)) : new Date()
    const created = new Date(normalizeDateString(dateString))
    const oneDayInMs = 24 * 60 * 60 * 1000
    const ageInDaysFloat = Math.abs((now.getTime() - created.getTime()) / (oneDayInMs))
    const ageInDays = Math.floor(ageInDaysFloat)
    return ageInDays
  } catch (e) {
    return 0
  }
}

export const daysSince = daysSinceNow

export const isPastDue = (date) => {
  return moment(date) < moment().startOf('day')
}
